/**
 * Paleta corporativa Tonal para todos los gráficos del módulo.
 * Igualar `frontend/CLAUDE.md` → "Colores Corporativos".
 */
export const TONAL_PALETTE = {
  blue: '#57a6d8',
  green: '#2fbc80',
  purple: '#8d82bc',
  pink: '#eb6587',
  yellow: '#f6c23e',
  gray: '#858796',
} as const

export type TonalColor = keyof typeof TONAL_PALETTE

export const SERIES_PALETTE: string[] = [
  TONAL_PALETTE.blue,
  TONAL_PALETTE.green,
  TONAL_PALETTE.purple,
  TONAL_PALETTE.pink,
  TONAL_PALETTE.yellow,
  TONAL_PALETTE.gray,
]

export function parseNumeric(value: unknown): number {
  if (value === null || value === undefined || value === '') return 0
  if (typeof value === 'number') return value
  const n = parseFloat(String(value))
  return Number.isNaN(n) ? 0 : n
}

/**
 * Configura el eje Y de categorías de las gráficas de barras horizontales.
 *
 * En el reporte Medifarma Perú (id 7) los labels se muestran COMPLETOS en una
 * sola línea: el eje se ensancha para acomodar el más largo, lo que acorta la
 * barra. En el resto de reportes se mantiene el ancho fijo y se trunca el label.
 *
 * @param labels     Todas las categorías del chart (para medir la más larga).
 * @param configId   Id del reporte; solo el 7 activa el modo "label completo".
 * @param anchoFijo  Ancho del eje usado fuera del reporte 7 (y piso mínimo en él).
 * @param truncar    Nº de caracteres al que se trunca fuera del reporte 7.
 * @param fontSize   Tamaño de fuente del tick (para estimar el ancho en px).
 * @param anchoMax   Tope del ancho del eje para que la barra no desaparezca.
 */
export function ejeCategoria(
  labels: string[],
  configId: number | undefined,
  {
    anchoFijo,
    truncar,
    fontSize = 11,
    anchoMax = 320,
  }: { anchoFijo: number; truncar: number; fontSize?: number; anchoMax?: number },
): { width: number; formatLabel: (s: string) => string } {
  const trunc = (s: string) => (s.length > truncar ? `${s.slice(0, truncar)}…` : s)
  if (configId !== 7) return { width: anchoFijo, formatLabel: trunc }
  const charPx = fontSize * 0.65
  const maxLen = labels.reduce((m, s) => Math.max(m, (s ?? '').length), 0)
  const width = Math.min(anchoMax, Math.max(anchoFijo, Math.ceil(maxLen * charPx) + 16))
  return { width, formatLabel: (s) => s }
}
